module.exports = __webpack_public_path__ + "img/dep_snacks@3x.beaee78e.png";